import { Contact } from '../../../../components/address-book/address-book-types';
import { AddressForm } from '../../../../global-types';

// Check if there are any changes in the address form compared to the contact data
export const didAddressChange = (addressForm: AddressForm, contactData: Contact | null | undefined): boolean => {
  // Check if the address form is empty or if the contact data is empty
  if (!addressForm || !contactData) {
    return true; // If either is empty, we consider it a change
  }

  // Compare each field in the address form with the contact data
  return (
    addressForm.first_name !== contactData.first_name ||
    addressForm.last_name !== contactData.last_name ||
    addressForm.address_line_1 !== contactData.address_line_1 ||
    addressForm.address_line_2 !== contactData.address_line_2 ||
    addressForm.company_name !== contactData.company_name ||
    addressForm.city !== contactData.city ||
    addressForm.state_code !== contactData.state_code ||
    addressForm.zip !== contactData.zip ||
    addressForm.country_code !== contactData.country_code
  );
};
